<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="template-page mt-5" v-else-if="loaded" >
        
        <div class="col-12 col-md-8 offset-md-2" >            
            <div class="row no-gutters" >
                <h2 class="h2 graymedium-color"  > Change Password </h2>
            </div>      
            <div class="row no-gutters mt-3" >            

                <b-form  @submit.prevent="submit" class="atlass-form col-12" >
                    <div class="row">
                        
                        <div class="col-12 form-group" >
                            <label for="password" > PASSWORD: </label>
                            <b-form-input id="password"
                                type="password"
                                v-model="password"
                                required
                                autocomplete="off"
                                placeholder="Password">
                            </b-form-input>
                        </div>
                        
                        <div class="col-12 form-group" >
                            <label for="passwordcheck" > PASSWORD CHECK: </label>
                            <b-form-input id="passwordcheck"
                                type="password"
                                v-model="passwordcheck"
                                required
                                autocomplete="off"
                                placeholder="Password check">
                            </b-form-input>
                        </div>
                        
                        <div class="col-12 mt-4" >
                            <b-button type="submit" variant="primary" class="btn-sm-w " >Save</b-button>
                            <div class="errors color-red" v-if="error != false" > {{ error }} </div>
                            
                            <spinner v-if="!requestLoaded" ></spinner>
                            
                        </div>
                        
                    </div>
                    
                </b-form>
                
                
            </div>
        </div>

    </div>

</template>

<script>
    
import { AUTH_LOGOUT, LOGOUT_ORG } from '@/store/actions/auth'
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default {
    name: 'passwordChange',
    props: {
        ID: { 
            type: [String],
        }
        
    },
    data: function(){
        return {
            error: false,
            loaded: false,
            requestLoaded: true,
            password: '',
            passwordcheck: '',
        }
    },
    ready: function (){
        
    },
    beforeCreate: function (){
        
    },
    mounted(){

        this.loaded = true
        
    },
    created: function () {
        
    },
    beforeDestroy() {
    },
    methods: {
        submit: function(){
            
            this.error = false
            
            if( this.password == this.passwordcheck && ( ( this.password.length >= 8 && !this.$store.getters.isAdmin ) || this.$store.getters.isAdmin ) ){
                
                this.requestLoaded = false
                
                //PREPARE REQUEST
                let params = Cookies.get('user-token')
                //let data = btoa( this.password )
                let data = {newPassword: btoa( this.password ) }
                //let data = JSON.stringify( this.newOrg )/
                let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "XAUTH": params }

                
                //SEND REQUEST
                axios({ method: 'POST', url: process.env.ROOT_API+'/user/change-password', headers: headers, data: data })
                    .then(resp => {

                    //console.log(resp)

                    if( resp.status == 200 ){
                        let r = resp.data;
                        if( r.status == 100 ){
                            //this.$parent.$parent.get_organizations()
                            this.$toast.success({
                                title: 'Success',
                                message: 'Successfully updated password. You will be redirected to login page'
                            })
                            this.requestLoaded = true
                            
                            //LOG OUT USER
                            setTimeout(function(){ 
                                 this.$parent.fModalClose()
                            }.bind(this), 1000 );
                            
                            setTimeout(function(){ 
                                 this.$store.dispatch(AUTH_LOGOUT)
                            }.bind(this), 1800 );
                            
                        }
                    }


                }).catch(error => {
                    console.log(error)
                }); //end axios 

            }else{
                
                this.error = "Passwords need to be at least 8 characters long and need to match each other."
                
            }
            
                
        },

           

    },
    computed: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/passwordChange.vue